import { createStore } from '../../lib/create-store';

import { reducer } from './reducer';
import { initialState } from './initial-state';

export const authStore = createStore({
  name: 'authStore',
  initialState,
  reducer,
});

export { actions as authActions } from './actions';
